import * as tp from 'io-ts-promise';
import axios from 'axios';
import { AxiosResponse } from 'axios';

import Data from '../../Data';
import Endpoints from '../endpoints';
import { getDataFromAxios } from '../common';
import { UserListResponse } from './response_models';

export const searchUsers = (term: string): Promise<AxiosResponse<UserListResponse>> =>
  axios.post(Endpoints.users.SEARCH(), { term }, Data.async.authorisationHeaders());

export default async (term: string) => await searchUsers(term).then(getDataFromAxios.get).then(tp.decode(UserListResponse));
